import { getStatusStyleName, getWalletStatusStyleName } from "../../helper/helper";
import "./StatusIndicator.scss"

interface StatusIndicatorType{
    incomingStatus: number,
    statusLabel?: string
    type?: string
}

const StatusIndicator = ({incomingStatus, statusLabel, type="vending"}: StatusIndicatorType) => {
    // const {styles, label} = getStatusStyleName(incomingStatus, statusLabel);
    // Determine styles and label based on type
    if(type === "wallet"){
        const { styles, label, backgroundColor, color } = getWalletStatusStyleName(incomingStatus,statusLabel); 
        return (
          <div className="flex items-center px-[8px] py-[6px] status-setter" style={{ backgroundColor }}>
            <div className={styles}></div>
            <p className="ml-[1px]" style={{ color }}>{label}</p>
          </div>
        );
    }
    const { styles, label, backgroundColor, color } = getStatusStyleName(incomingStatus,statusLabel); 

    
  return (
    <div className="flex items-center px-[8px] py-[6px] status-setter" style={{ backgroundColor }}>
      <div className={styles}></div>
      <p className="ml-[1px]" style={{ color }}>{label}</p>
    </div>
  );
};

export default StatusIndicator;
